import $ from "jquery";

$("#blogs-grid-filter-destinations").on("change", function () {
    const selectedValue = $(this).val();

    if (selectedValue === "all") {
        window.location.href = PAGE_URL;
    } else {
        window.location.href = `${PAGE_URL}?destinations[]=${selectedValue}`;
    }
});
